<template>
  <div class="content-wrap">
    <el-form :inline="true">
      <el-form-item label="客服">
        <tjkautocompleteall @change="updateTjkId"></tjkautocompleteall>
      </el-form-item>
      <el-form-item label="参培情况">
        <el-select v-model="searchData.tjkJoin" placeholder="请选择" clearable>
          <el-option key="noJoin" label="未参培" value="noJoin"></el-option>
          <el-option key="abandonNoSay" label="中途退出（无报备）" value="abandonNoSay"></el-option>
          <el-option key="abandonAndSay" label="中途退出（有报备）" value="abandonAndSay"></el-option>
          <el-option key="joinComplete" label="完整参培" value="joinComplete"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台考核">
        <el-select v-model="searchData.platformAppraise" clearable placeholder="请选择">
          <el-option key="pass" label="通过" value="pass"></el-option>
          <el-option key="nopass" label="未通过" value="nopass"></el-option>
          <el-option key="reject" label="拒考" value="reject"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商家考核">
        <el-select v-model="searchData.merchantAppraise" clearable placeholder="请选择">
          <el-option key="pass" label="通过" value="pass"></el-option>
          <el-option key="nopass" label="未通过" value="nopass"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="录取状态">
        <el-select v-model="searchData.enrollState" clearable placeholder="请选择">
          <el-option key="Yes" label="录取" value="Yes"></el-option>
          <el-option key="No" label="释放" value="No"></el-option>
          <el-option key="None" label="暂未处理" value="None"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="getExcel">下载查询结果</el-button>
        <el-dropdown @click="doDownload" @command="doDownload">
          <el-button type="primary">
            下载<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="51">下载平台考核</el-dropdown-item>
            <el-dropdown-item command="52">下载商家考核</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <label class="upload-btn pic-upload-btn">
          <span>导入平台考核</span>
          <input ref="referenceUpload" class="file tj-btn tj-btn-blue" name="file" type="file" accept=".xls,.xlsx" @change="importExcel($event)" />
        </label>
        <label class="upload-btn pic-upload-btn">
          <span>导入商家考核</span>
          <input ref="referenceUploadMerchant" class="file tj-btn tj-btn-blue" name="file" type="file" accept=".xls,.xlsx" @change="importMerchantExcel($event)" />
        </label>
        <el-button type="primary" @click="enroll('Yes')">录取</el-button>
        <el-button type="primary" @click="enroll('No')">释放</el-button>
        <el-button type="primary" @click="getTjkJoin">参培生成</el-button>
        <!--<el-button type="primary" @click="getExcel">编辑考核模板</el-button>-->
      </el-form-item>
    </el-form>

    <div class="search-box" v-if="tableData.length>0">
        <el-scrollbar class="scroll-bar-x" viewStyle="display: inline-block; min-width: 100%;">
          <children :dataArr="headList">
            <tr v-for="(trlist, trIndex) in finalTableData" class="formcontent">
              <td v-for="(item, index) in trlist">
                <template v-if="item.type == 'TEXT'">
                  <span v-if="index==0 || index==4">{{finalTableData[trIndex][index].value}}</span>
                  <template v-else>
                    <template v-if="finalTableData[trIndex][index].value != '' && finalTableData[trIndex][index].value != null">
                      <el-tooltip class="item" effect="dark" :content="finalTableData[trIndex][index].value" placement="top">
                        <el-input v-model="finalTableData[trIndex][index].value"  style="width: 85%;height: 40px;" editable="false"></el-input>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <el-input v-model="finalTableData[trIndex][index].value"  style="width: 85%;height: 40px;" editable="false"></el-input>
                    </template>
                  </template>
                </template>
                <template v-if="item.type == 'SELECT'">
                  <el-select v-model="finalTableData[trIndex][index].value" filterable style="width: 100px;">
                    <el-option v-for="(m, key) in item.fieldOptions" :key="m.value" :label="m.describe" :value="m.value"></el-option>
                  </el-select>
                </template>
              </td>
                <td>
                  <template v-if="trlist.length>0">
                    <span style="color:cornflowerblue;margin:3px 3px;float:left" class="link-text" @click="saveTjkJoin(tableData[trIndex], finalTableData[trIndex] )">保存</span>
                    <span style="color:cornflowerblue;margin:3px 3px;float:left" class="link-text" @click="delTjk(tableData[trIndex])">删除</span>
                  </template>
                </td>
            </tr>
          </children>
        </el-scrollbar>
    </div>

    <el-dialog :title="(searchData.enroll=='Yes')?'录取':'释放'" :visible.sync="dialogEnrollVisible" center width="30%">
      <el-form>
        <el-form-item label="通知消息" label-width="120px">
          <el-input type="textarea" v-model="searchData.msg" autocomplete="off" :rows="6" style="width:350px;"></el-input>
        </el-form-item>
        <el-form-item v-if="this.searchData.enroll == 'Yes' && this.way=='Excel'" label="录取到店铺" label-width="120px">
          <el-select
            v-model="searchData.shopId" filterable remote placeholder="请设置目标店铺" :remote-method="queryShopIdByName">
            <el-option
              v-for="item in shopOptions"
              :label="item.shopName"
              :value="item.id"
              :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEnrollVisible = false">取 消</el-button>
        <el-button type="primary" @click="doEnroll">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      searchData: {
        scheduleId: this.$route.query.scheduleId,
        tjkId: '',
        tjkJoin: '',
        platformAppraise: '',
        merchantAppraise: '',
        enrollState: '', //录取状态
        //以下几个参数是录取时候用，shopId是Excel方式下的选择店铺
        shopId:'',
        shopName:'',
        enroll:'',
        msg:''
      },
      way:'',//tjk来源，Excel,Shop,WorkOrder
      tableData: [],
      headList: [],
      columnData: [],
      finalTableData: [],

      dialogEnrollVisible:false,
      shopOptions:[],
      tjkOpeData: {
        appraiseId: '',
        tjkJoin: '',//临时tjkJoin参数，用于当行的参培情况保存设置的临时变量
        scheduleId: this.$route.query.scheduleId,//删除时候使用
        tjkId: ''//删除时候使用
      },
      passStatus:{
        'pass':'通过',
        'nopass':'未通过',
        'reject':'拒绝'
      },
      tjkJoin:{
        'noJoin':'未参培',
        'abandonNoSay':'中途退出（无报备）',
        'abandonAndSay':'中途退出（有报备）',
        'joinComplete':'完整参培'
      }

    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    //列表页淘金客自动搜索
    updateTjkId(val) {
      this.searchData.tjkId = val
    },
    getList() {
      var self = this;
      this.$http.post(API_ROOT.college + '/appraise/queryTjkUser', this.searchData).then(response => {
        var result = response.data;
        if(result.success) {
          self.headList = result.data.headerInfos;
          self.tableData = result.data.dataList;
          self.way = result.data.way;

          self.finalTableData = [];
          //生成表格内容数据finalTableData
          for(let i=0;i<self.tableData.length;i++) {
            var curLineData = self.tableData[i];
            let tempTableData = [];

            //j为head总列数
            for(let j=0;j<self.headList.length;j++) {
              var head = self.headList[j];
              //非动态
              if(self.headList[j].dynamicForm == false) {
                  var value = curLineData[head.fieldName];
                  var dataCell = this.setObjectForFinalTable(head, value);
                  tempTableData.push(dataCell);
              }

              //动态
              if(self.headList[j].dynamicForm == true) {
                if(head.children.length > 0){
                  for(var ch = 0; ch < head.children.length; ch++){

                    var headChild = head.children[ch];
                    if(curLineData.fieldValueList){
                      for(var f=0;f < curLineData.fieldValueList.length;f++) {
                        if(headChild.id == curLineData.fieldValueList[f].fieldId) {
                          var dataCell = this.setObjectForFinalTable(headChild, curLineData.fieldValueList[f].value);
                          tempTableData.push(dataCell);
                          break;
                        }
                      }
                    }
                  }
                }else{
                  var headChild = head;
                  if(curLineData.fieldValueList){
                    for(var f=0;f < curLineData.fieldValueList.length;f++) {
                      if(headChild.id == curLineData.fieldValueList[f].fieldId) {
                        var dataCell = this.setObjectForFinalTable(headChild, curLineData.fieldValueList[f].value);
                        tempTableData.push(dataCell);
                        break;
                      }
                    }
                  }
                }

              }

            }
            self.finalTableData.push(tempTableData)
          }

        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //设置一个cell值给finalTable,[head.type, value, head.fieldOptions, head.id]->[input、select输入框， 值， select组件时的下拉可选项， 动态表单cell的fieldId]
    setObjectForFinalTable(head, value) {
      var dataCell = new Object();
        dataCell.type = head.type;
        dataCell.value = value;
        dataCell.fieldOptions = head.fieldOptions;
        dataCell.fieldId = head.id;
      return dataCell;
    },
    //导出查询结果
    getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'))
      var login_token = (arr != null) ? unescape(arr[2]) : null

      var url = API_ROOT.college + '/appraise/exportNamelistApprise?tjk_login_token=' + login_token + '&scheduleId=' + this.searchData.scheduleId + '&tjkId=' + this.searchData.tjkId + '&tjkJoin=' + this.searchData.tjkJoin + '&platformAppraise=' + this.searchData.platformAppraise + '&merchantAppraise=' + this.searchData.merchantAppraise + '&enrollState=' + this.searchData.enrollState
      window.open(url)
    },
    //导入文件-平台考核
    importExcel(event) {
      var self = this
      var file = event.target.files[0]
      if(!file) {
        return
      }
      this.$refs.referenceUpload.value = null;
      event.preventDefault();
      let formData = new FormData();
      formData.append('name', file.name);
      formData.append('file', file);
      formData.append('scheduleId', this.searchData.scheduleId);
      formData.append('templateId', 51);

      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
          token = (arr != null) ? unescape(arr[2]) : null
      formData.append('login_token', token);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data;'
        }
      }
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = (arr != null) ? unescape(arr[2]) : null;
      const ajax = axios.create({})
      ajax.post(API_ROOT.college + "/appraise/uploadAppraiseExcel?tjk_login_token="+login_token, formData, config).then(response=> {
        var result = response.data
        if(result.success) {
          this.getList();
          self.$message({
            message: '导入成功',
            type: 'success'
          })
        }else {
          self.$alert(result.msg)
        }
      },response=> {
        self.$alert("网络繁忙，请稍后重试！")
      })
    },
    //导入文件-商家考核
    importMerchantExcel(event) {
      var self = this
      var file = event.target.files[0]
      if(!file) {
        return
      }
      this.$refs.referenceUploadMerchant.value = null;
      event.preventDefault();
      let formData = new FormData();
      formData.append('name', file.name);
      formData.append('file', file);
      formData.append('scheduleId', this.searchData.scheduleId);
      formData.append('templateId', 52);

      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
          token = (arr != null) ? unescape(arr[2]) : null
      formData.append('login_token', token);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data;'
        }
      }
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = (arr != null) ? unescape(arr[2]) : null;
      const ajax = axios.create({})
      ajax.post(API_ROOT.college + "/appraise/uploadAppraiseExcel?tjk_login_token="+login_token, formData, config).then(response=> {
        var result = response.data
        if(result.success) {
          this.getList();
          self.$message({
            message: '导入成功',
            type: 'success'
          })
        }else {
          self.$alert(result.msg)
        }
      },response=> {
        self.$alert("网络繁忙，请稍后重试！")
      })
    },
    //下载
    doDownload(command) {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = (arr != null) ? unescape(arr[2]) : null;
      var cond = '&scheduleId=' + this.searchData.scheduleId
          + '&tjkId=' + this.searchData.tjkId
          + '&tjkJoin=' + this.searchData.tjkJoin
          + '&platformAppraise=' + this.searchData.platformAppraise
          + '&merchantAppraise=' + this.searchData.merchantAppraise
          + '&enrollState=' + this.searchData.enrollState;

      if(command == 51) {
        var url = API_ROOT.college + '/appraise/exportPlatformApprise?tjk_login_token=' + login_token + '&templateId=51' + cond
        window.open(url)
      }
      if(command == 52) {
        var url = API_ROOT.college + '/appraise/exportMerchantApprise?tjk_login_token=' + login_token + '&templateId=52' + cond
        window.open(url)
      }
    },
    queryShopIdByName(query){
      this.searchData.shopName = query;
      this.$http.post(API_ROOT.college + '/appraise/queryShop', this.searchData).then(response => {
        var result = response.data;
        if(result.success) {
          this.shopOptions = result.data;
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //录取
    enroll(type){
      if(enrollState =='Yes' || enrollState == 'No'){
          if(enrollState != type){
              this.$alert("录取条件下不能进行释放操作，释放条件下不能进行录取操作");
              return;
          }
      }
      this.searchData.enroll = type;
      this.dialogEnrollVisible=true;
    },
    doEnroll(){
      this.$http.post(API_ROOT.college + '/appraise/enrollTjk', this.searchData).then(response => {
       var result = response.data;
       if(result.success) {
           this.getList();
         this.$alert("操作成功");
       }else {
         this.$alert(result.msg)
       }
     }, response => {
       this.$alert('网络繁忙，请稍后重试！')
     });
     this.dialogEnrollVisible = false;
    },
    saveTjkJoin(data, finaldata){
      var self = this;
      var appraiseId = data.appraiseId;
      var tjkId = data.tjkId;
      this.tjkOpeData.appraiseId = appraiseId;
      this.tjkOpeData.tjkId = tjkId;
      this.tjkOpeData.tjkJoin = finaldata[1].value;
      this.tjkOpeData.merchantAppraise = finaldata[2].value;
      this.tjkOpeData.platformAppraise = finaldata[3].value;
      var fieldValueList = [];
      for(var i=5; i<finaldata.length; i++){
          fieldValueList.push(finaldata[i]);
      }
      this.tjkOpeData.fieldValueList = fieldValueList;
      this.$http.post(API_ROOT.college + '/appraise/updateTjkJoinByAppraiseId', this.tjkOpeData).then(response => {
        var result = response.data;
        if(result.success) {
            this.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
            });
            this.getList();
        }else {
            this.$alert(result.msg)
        }
      }, response => {
          self.$alert('网络繁忙，请稍后重试！')
      })
    },
    delTjk(data) {
        this.tjkOpeData.tjkId = data.tjkId;
        this.$http.post(API_ROOT.college + '/appraise/delTjkByScheduleIdAndTjkId', this.tjkOpeData).then(response => {
            var result = response.data;
            if(result.success) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    center: true,
                    duration: 1000
                });
                this.getList();
            }else {
                this.$alert(result.msg)
            }
        }, response => {
            this.$alert('网络繁忙，请稍后重试！')
        })
    },
    //参培生成
    getTjkJoin() {
        this.$http.post(API_ROOT.college+ '/appraise/generateTjkJoin', {'scheduleId': this.searchData.scheduleId}).then(response => {
            var result = response.data;
            if(result.success) {
                this.getList();
                this.$alert("参培生成成功");
            }else {
                this.$alert(result.msg)
            }
        }, response => {
            this.$alert('网络繁忙，请稍后重试！')
        });
    }

  }
}
</script>

<style lang="less" scoped>
.table {
  border-left: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
  width: 100%;
  text-align: center;
  thead {
    color: #909399;
    font-weight: 500;
    th {
      background: #e2e2e2 !important;
      color: #333333 !important;
      border-bottom: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
      text-align: center;
      width: 100px;
    }
  }
  tr {
    background-color: #ffffff;
    td {
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
  }
}
.el-dropdown {
  margin: 0 10px;
}
.upload-btn {
  position: relative;
  margin: 0;
  cursor: pointer;
  &.pic-upload-btn {
    display: inline-block;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    background-color: #2197ff !important;
    border: 1px solid #2197ff;
    border-radius: 2px !important;
    padding: 0px 14px !important;
    height: 36px !important;
    line-height: 34px !important;
    margin-right: 10px;
  }
  input {
    display: none
  }
  .filename {
    word-break: break-all;
  }
}
.link-text {
  display: inline-block;
  margin: 3px;
  cursor: pointer;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// ./src/page/trainCheck/trainNameList.vue